import React from 'react';
import { Spin } from 'antd';
import { CheckCircleOutlined, LoadingOutlined } from '@ant-design/icons';
import './BarcodeScannerOverlay.scss';

const BarcodeScannerOverlay = ({ isScanning, barcodeFound, isSearching, scannedBarcode }) => {
  if (!isScanning && !barcodeFound && !isSearching) return null;

  return (
    <div className="barcode-scanner-overlay">
      {/* Blur overlay peste tot, cu gaură în centru */}
      <div className="barcode-scanner-overlay__blur-top"></div>
      <div className="barcode-scanner-overlay__blur-bottom"></div>
      <div className="barcode-scanner-overlay__blur-left"></div>
      <div className="barcode-scanner-overlay__blur-right"></div>
      
      {/* Dreptunghi de scanare în centru */}
      <div className={`barcode-scanner-overlay__scan-area ${barcodeFound ? 'barcode-scanner-overlay__scan-area--success' : ''}`}>
        <div className={`barcode-scanner-overlay__corner barcode-scanner-overlay__corner--top-left ${barcodeFound ? 'barcode-scanner-overlay__corner--success' : ''}`}></div>
        <div className={`barcode-scanner-overlay__corner barcode-scanner-overlay__corner--top-right ${barcodeFound ? 'barcode-scanner-overlay__corner--success' : ''}`}></div>
        <div className={`barcode-scanner-overlay__corner barcode-scanner-overlay__corner--bottom-left ${barcodeFound ? 'barcode-scanner-overlay__corner--success' : ''}`}></div>
        <div className={`barcode-scanner-overlay__corner barcode-scanner-overlay__corner--bottom-right ${barcodeFound ? 'barcode-scanner-overlay__corner--success' : ''}`}></div>
        
        {/* Feedback verde când se găsește barcode-ul */}
        {barcodeFound && (
          <div className="barcode-scanner-overlay__success-indicator">
            <CheckCircleOutlined style={{ fontSize: '48px', color: '#52c41a' }} />
            <p style={{ marginTop: '12px', color: '#52c41a', fontWeight: 'bold' }}>
              Cod detectat!
            </p>
            {scannedBarcode && (
              <p style={{ marginTop: '4px', fontSize: '12px', color: '#52c41a', opacity: 0.8 }}>
                {scannedBarcode}
              </p>
            )}
          </div>
        )}
      </div>
      
      {/* Mesaj de instrucțiuni sau loader */}
      {isSearching ? (
        <div className="barcode-scanner-overlay__loading">
          <Spin 
            indicator={<LoadingOutlined style={{ fontSize: 32, color: '#52c41a' }} spin />} 
            size="large"
          />
          <p style={{ marginTop: '16px', color: 'white', fontSize: '16px', fontWeight: '500' }}>
            Căutare produs...
          </p>
        </div>
      ) : (
        <div className="barcode-scanner-overlay__instructions">
          <p>Ține codul de bare în cadrul dreptunghiului</p>
          <p className="barcode-scanner-overlay__instructions-hint">Funcționează în orice orientare</p>
        </div>
      )}
    </div>
  );
};

export default BarcodeScannerOverlay;

